/* eslint-disable */
import axios from 'axios'
import customSelect from 'custom-select'
import setAttributes from '../utils/setAttributes'
import { create as createPipe } from '../utils/sigpipe'

import { get as getPipe } from '../utils/sigpipe'

import translate from '../translations'

import cardTpl from './cards-templates/edit-activity'

export default {
  name: 'member-form-activities',

  /*ui: {
    select: '[js-custom-select]',
  },

  events: [
    {
      target: 'select',
      on: 'change',
      handle(e) {
        this.addActivity(
          this.ui.select.value,
          this.ui.select.options[this.ui.select.selectedIndex].text
        )
        
        this.cstSel.remove(cstSel.select.options[this.ui.select.selectedIndex])

        this.updateCounter()
      },
    },
  ],*/

  componentDidMount() {
    this.pipe = createPipe()
    setAttributes({ dataPipeId: `${this.pipe.id}` })(this.el)

    this.pipe.on(({ action, data }) => {
      if (action === 'activity-removed') {
        this.removeActivity(data)
      }
    })

    this.route = this.props && this.props.route ? this.props.route : '/'
    this.list = this.el.querySelector('.activities-list')
    this.counter = this.el.querySelector('.activities-counter')
    this.select = this.el.querySelector('select')

    setTimeout(() => {
      this.cstSel = this.el.querySelector('select').customSelect
      this.cstSel.select.addEventListener('change', e => {
        this.addActivity(
          this.select.value,
          this.select.options[this.select.selectedIndex].text
        )
      })
    }, 300)
  },

  updateCounter() {
    const nb = this.list.querySelectorAll('.activity').length
    this.counter.innerText =
      nb > 1
        ? `${nb} ${translate('ACTIVITIES_ADDED')}`
        : `${nb} ${translate('ACTIVITIY_ADDED')}`
  },

  addActivity(value, text) {
    const data = {}
    data.id = value
    data.text = text
    if (value === '') return

    this.list.innerHTML = cardTpl(data) + this.list.innerHTML

    this.cstSel.remove(this.cstSel.select.options[this.select.selectedIndex])

    this.request('create', value)
  },

  removeActivity(data) {
    const value = data.props.activityID
    const text = data.el.querySelector('.gen-text--S').innerHTML

    const option = document.createElement('option')
    option.text = text
    option.value = value
    this.cstSel.append(option)

    this.list.removeChild(data.el)

    this.request('delete', value)
  },

  request(pAction, value) {
    this.updateCounter()
    /* let formData = new FormData()
    formData.append('action', pAction)
    formData.append('id', value)

    axios
      .post(this.route, formData)
      .then(response => {
        // console.log(response.data)
        this.updateCounter()
      })
      .catch(function(error) {
        // handle error
        console.log(error)
      }) */
  },
}
